<template>
  <!-- Sản phẩm đổi -->
  <div class="__card__order-return mt-3">
    <h1 class="__card__order-return_title">Sản phẩm đổi</h1>
    <el-form class="mb-2" @submit.native.prevent style="width: 100%;">
      <el-row :gutter="16">
        <el-col :span="19" :lg="19" :md="19" :xs="19">
          <!-- input -->
          <InputSearch class="input-search-pos" notShowHead :datas="datas"></InputSearch>
        </el-col>
        <el-col :span="5" :lg="5" :md="5" :xs="5">
          <el-popover trigger="click" width="200">
            <el-button disabled slot="reference" class="w-100 btn-fix-sỉze">Thao tác nhanh</el-button>
            <div class="quick-handle">
              <!-- <div class="quick-handle_btn">Trả tất cả</div>
              <div class="quick-handle_btn text-danger">Bỏ chọn</div> -->
            </div>
          </el-popover>
        </el-col>
      </el-row>
    </el-form>

    <!-- table -->
    <Cart :datas="datas"/>
    <Item :datas="datas"/>

    <CalculationMoney :datas="datas"></CalculationMoney>
    <BottomPrice></BottomPrice>
  </div>
</template>

<script>
import InputSearch from "../../V2/pos/components/InputSearch.vue";
import Cart from "../../V2/pos/components/cart"
import Item from "../../V2/pos/components/item"
import BottomPrice from "./bottomPrice.vue";

import {mapMutations} from "vuex"
import CalculationMoney from "./calculationMoney.vue";

import { SettingService } from "../../../services/nextshop/setting.service";


export default {
  components: { InputSearch, Cart, Item, BottomPrice, CalculationMoney },
  props: {
    datas: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      
    };
  },
  async created() {
    try {
      await this.initPos()
      await this.getDataMerchant()
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    ...mapMutations("sell", ["SET_RM_ID"]),
    initPos() {
      this.SET_RM_ID(0)
    },
    async getDataMerchant() {
      try {
        const response = await SettingService.getDataMerchant()
        if (response.success) {
          this.datas.activeNegativeInv = response.data.merchant.activeNegativeInv
          this.datas.enableInventory = response.data.merchant.enableInventory
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.bottom-border {
  width: 100%;
  border-bottom: 1px solid #f2f3f4;
}
</style>

<style lang="scss">
.input-search-pos {
  .bottomHeadSearch {
    width: 100%;
    z-index: 10;
  }
}</style>
